"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var BASE = "https://tenor.com/view/";
var Result = /** @class */function (_super) {
  __extends(Result, _super);
  function Result(props) {
    var _this = _super.call(this, props) || this;
    _this.handleClick = function () {
      var _a = _this.props,
        result = _a.result,
        onSelect = _a.onSelect;
      onSelect(result);
    };
    _this.componentIsMounted = false;
    _this.image = new Image();
    _this.state = {
      loaded: false
    };
    return _this;
  }
  Result.prototype.componentDidMount = function () {
    var _this = this;
    this.componentIsMounted = true;
    var result = this.props.result;
    this.image.src = result.media[0].tinygif.url;
    this.image.onload = function () {
      if (_this.componentIsMounted) {
        _this.setState({
          loaded: true
        });
      }
    };
  };
  Result.prototype.componentWillUnmount = function () {
    this.componentIsMounted = false;
  };
  Result.prototype.getLabel = function () {
    var itemurl = this.props.result.itemurl;
    return itemurl.replace(BASE, "").replace(/-gif-\d+$/, "").replace(/-/g, " ");
  };
  Result.prototype.render = function () {
    var loaded = this.state.loaded;
    return React.createElement("button", {
      "aria-label": this.getLabel(),
      type: "button",
      onClick: this.handleClick,
      className: "react-tenor--result"
    }, loaded && React.createElement("span", {
      style: {
        backgroundImage: "url(" + this.image.src + ")"
      }
    }));
  };
  return Result;
}(React.Component);
exports.default = Result;